module.exports = __webpack_public_path__ + "static/img/simulator.79e3f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/homepage/simulator.png
// module id = YvY5
// module chunks = 1